import { useTranslation } from "next-i18next";
import Image from "next/image";

const CloudRentalInstallationProcess = () => {
    const { t } = useTranslation(["common", "cloudServer"]);

    return (
        <div className="py-8 lg:py-16 bg-buttonBg">
            <div className="container mx-auto">
                <h2 className="mb-4 text-3xl font-bold text-center lg:text-4xl text-titleColor">{t("cloudServer:cloudRentalInstallationProcess")}</h2>
                <div className="text-center text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:cloudRentalInstallationProcessDesc") }}></div>

                <div className="grid px-4 pt-12 lg:grid-cols-2">
                    <div>
                        <Image src={"/rentalCloudServer.png"} width={520} height={491} alt={t("cloudServer:cloudRentalInstallationProcess")} title={t("cloudServer:cloudRentalInstallationProcess")} />
                    </div>

                    <div className="lg:h-[584px] overflow-y-auto scrollbar-custom  lg:pr-10 space-y-8">
                        <h3 className="font-semibold text-titleColor">{t("cloudServer:cloudRentalInstallationProcessDesc8")}</h3>
                        <div className="text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:cloudRentalInstallationProcessDesc2") }}></div>
                        <p className="text-textGray">🔹{t("cloudServer:cloudRentalInstallationProcessDesc3")}</p>
                        <p className="text-textGray">🔹{t("cloudServer:cloudRentalInstallationProcessDesc4")}</p>
                        <p className="text-textGray">🔹{t("cloudServer:cloudRentalInstallationProcessDesc5")}</p>
                        <div className="text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:cloudRentalInstallationProcessDesc6") }}></div>
                        <p className="text-textGray">{t("cloudServer:cloudRentalInstallationProcessDesc7")}</p>

                        <h3 className="font-semibold text-titleColor">{t("cloudServer:userFriendlyAdministrationPanel")}</h3>
                        <div className="text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:userFriendlyAdministrationPanelDesc") }}></div>
                        <p className="text-textGray">📌 {t("cloudServer:userFriendlyAdministrationPanelDesc2")}</p>
                        <p className="text-textGray">📌 {t("cloudServer:userFriendlyAdministrationPanelDesc3")}</p>
                        <p className="text-textGray">📌 {t("cloudServer:userFriendlyAdministrationPanelDesc4")}</p>
                        <p className="text-textGray">📌 {t("cloudServer:userFriendlyAdministrationPanelDesc5")}</p>
                        <div className="text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:userFriendlyAdministrationPanelDesc6") }}></div>


                        <h3 className="font-semibold text-titleColor">{t("cloudServer:configurationOptionsAndAdditionalServices")}</h3>
                        <div className="text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:configurationOptionsAndAdditionalServicesDesc") }}></div>
                        <p className="text-textGray">✅ {t("cloudServer:configurationOptionsAndAdditionalServicesDesc2")}</p>
                        <p className="text-textGray">✅ {t("cloudServer:configurationOptionsAndAdditionalServicesDesc3")}</p>
                        <p className="text-textGray">✅ {t("cloudServer:configurationOptionsAndAdditionalServicesDesc4")}</p>
                        <p className="text-textGray">✅ {t("cloudServer:configurationOptionsAndAdditionalServicesDesc5")}</p>
                        <p className="text-textGray">✅ {t("cloudServer:configurationOptionsAndAdditionalServicesDesc6")}</p>
                        <p className="text-textGray">✅ {t("cloudServer:configurationOptionsAndAdditionalServicesDesc7")}</p>
                        <div className="text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:configurationOptionsAndAdditionalServicesDesc8") }}></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CloudRentalInstallationProcess